<template>
  <div :class="b()">
    <input :class="b('name')" type="text" v-model="name" @keyup.enter="actionApply">
    <el-checkbox :class="b('choose')" border v-model="choose">Отобразить</el-checkbox>
    <el-button @keyup.enter="actionApply" @click="actionApply">Принять</el-button>
    <el-button @click="actionCancel">Отменить</el-button>
  </div>
</template>

<script>

    import Vue from 'vue';
    import {Button} from 'element-ui';
    import {EventBus} from "../event-bus";

    Vue.use(Button);

    const COMPONENT_NAME = 'name-input';

    export default {
        name: COMPONENT_NAME,
        props: ['context', 'value'],
        data() {
            return {
                name: '',
                choose: false,
            };
        },
        created() {
            if (!_.isNull(this.value) && !_.isUndefined(this.value)) {
                this.name = this.value;
            }
        },
        methods: {
            actionApply() {
                EventBus.$emit('name-edit', this.context, this.name, Number(this.choose));
                this.$vuedals.close();
            },
            actionCancel() {
                this.$vuedals.close();
            }
        }
    }
</script>

<style scoped lang="scss">
  .name-input {
    display: flex;
    justify-content: space-between;

    &__name {
      flex-grow: 1;
      margin-right: 10px;
      align-self: stretch;
    }

    &__choose{
      margin: auto;
      margin-right: 10px !important;
    }
  }
</style>